module.exports = __webpack_public_path__ + "img/tab-2.cbf10ecc.png";